import React from "react";

/**
 * Kop boven de pagina-inhoud, gevoed door de route-config
 * (`currentRouteInfo.breadcrumb` / `.title` in layouts/app-layout).
 *
 * De breadcrumb die hier stond is verhuisd naar de vaste headerbalk, naast het
 * meldingencentrum — zie components/layout-components/HeaderBreadcrumb.js. De
 * oude `AppBreadcrumb` is verwijderd: die was per-segment opgebouwd (en dus
 * ongeschikt voor een groepsnaam als "Inkoop" die niet in de URL voorkomt) en
 * hij was kapot — `const { location } = useLocation()` levert undefined, dus hij
 * rendeerde altijd een leeg element. Vandaar dat hij hier uitgecommentarieerd
 * stond.
 */
export const PageHeader = ({ title, display }) => {
  return display ? (
    <div className="app-page-header">
      <h3 className="mb-2 mr-3 font-weight-semibold">{title ? title : "Home"}</h3>
    </div>
  ) : null;
};

export default PageHeader;
